import { Element } from "@xmpp/xml"
import {
  DocumentDriverContext,
  MessageDisplayType,
} from "@/reducers/messagesSlice"
import MessageParser from "./messageParser"
import LocationParser from "@/lib/locationParser"

export default class DocumentDriverContextParser {
  static parse(
    stanza: Element,
    timestamp?: string,
  ): DocumentDriverContext | undefined {
    const documentDriverContextNode = stanza.getChild("document-driver-context")

    if (!documentDriverContextNode) return

    const locationNode = documentDriverContextNode.getChild(
      "geoloc",
      "http://jabber.org/protocol/geoloc",
    )

    if (!locationNode) return

    const location = LocationParser.parseGeoloc(locationNode)

    return {
      id: MessageParser.id(stanza, false),
      to: stanza.attrs.to,
      from: stanza.attrs.from,
      messageId: documentDriverContextNode.attrs["message_id"],
      timestamp: timestamp || new Date().toISOString(),
      displayType: MessageDisplayType.DocumentDriverContext,
      type: stanza.attrs.type,
      plates: documentDriverContextNode.attrs["plates"],
      location,
    } as DocumentDriverContext
  }
}
